<!-- A title section with a folding body and possible button actions -->
<script lang="ts" setup>
  import { ref,computed } from 'vue';
  import FoldingPanel from "../components/FoldingPanel.vue"; 
  import ActionButton from "../components/ActionButton.vue"; 
  import {IActionButtons,billingBaseClass,spinnerClassSmall} from '../lib/Types/Types';

  const actionPanel = ref<boolean>(true);  

  const props = withDefaults(defineProps<{
      panelTitle: string, 
      actionTitle?: string  
      actionList?: IActionButtons,
      collapseClass?: string,
      expandClass?: string,
  }>(),
  { 
      collapseClass: "col-sm-10",
      expandClass: "col-sm-2",
  });

  const hasActions = computed(() => props.actionList ? true : false);
  const endPadding = computed(() => actionPanel.value ? 0 : 1);

  const emit = defineEmits<{
        (e: "update:actionPanel", isOpen: boolean): void
    }>();
    
  function onUpdate(isPanelOpened: boolean)  { 
    actionPanel.value = isPanelOpened;
    emit("update:actionPanel", isPanelOpened);
  } 
</script>

<style scoped>
     .viewDisplay {
        display: block;
    }
    .viewHide {
        display: none;
    }
    .cardActions {
        font-size: .85rem;
        font-weight: 500;
        color: #204D89;  
    }
</style>

<template>  
  <div class="row">
    <div  :class="(!hasActions ? 'col-sm-12' : (actionPanel ? 'col-sm-10' : expandClass))">
        <FoldingPanel @update:panelOpen="onUpdate" cssFramework="billing"> 
          <template #title>
            <span class="cardActions">{{props.panelTitle}}</span>
          </template>

          <template #body>
              <slot name="body">
                  <span style="color:red">Need slot data: body</span>
              </slot>
          </template>
        </FoldingPanel>
    </div>
    <div v-if="hasActions" :class="actionPanel ? 'col-sm-2' + ' text-center ' : collapseClass + ' text-end '" style="z-index: 999; background-color: white;"> 
      <h5 class="cardActions">
        <span>{{props.actionTitle}}</span>
      </h5>
      <span v-for="item in props.actionList ">
        <span style="font-size: 1.25rem;"> 
          <ActionButton
            :executing="item.executing"    
            :id="item.id"    
            :baseText="item.baseText"    
            :baseClass="item.baseClass ?? billingBaseClass"    
            :disabled="item.disabled"    
            :clickEvent="item.clickEvent" 
            :width="item.width"
            :toolTip="item.toolTip"
            :iconClass="item.iconClass"
            :spinText="item.spinText"
            :spinClass="item.spinClass ?? spinnerClassSmall"
            :overRideStyle="item.overRideStyle"
            :endingPadding="endPadding">
          </ActionButton>     
        </span>
        <br v-if="actionPanel"/>  
      </span> 
      <br/>  
      <br v-if="!actionPanel"/>  
    </div> 
  </div>
</template> 
